import React from 'react'
import instagram from "../images/1298747_instagram_brand_logo_social media_icon.png"
import twitter from "../images/512px-X_logo_2023_(white).png"
import linkedin from "../images/5296501_linkedin_network_linkedin logo_icon.png"
import github from "../images/github (1).png"


export default function RespSidebar(props) {
  return (
    <>
        <aside
    className="sidebar active"
    data-sidebar=""
        >
        <div className="sidebar-info">
          <figure className="avatar-box">
            <img
              alt="Ujwal Hiranwar"
              className="rounded-3xl"
              src="https://i.ibb.co/Gp292WF/ujwal.png"
              width="80"
            />
          </figure>
          <div className="info-content">
            <h1 className="name" title="Ujwal Hiranwar">
              Ujwal Hiranwar
            </h1>
            <p className="title">Web Developer/DevOps Enthusiast</p>
          </div>
          <button className="info_more-btn mr-[20px] mt-[10px] sm:mb-[63px]" onClick={()=>{
            props.setDropDown(false)
          }}>
            

            <svg xmlns="http://www.w3.org/2000/svg" class="ionicon spring sm:m-[-13px]" viewBox="0 0 512 512"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="48" d="M112 328l144-144 144 144"/></svg>
          </button>
        </div>
        <div className="sidebar-info_more ">
          <div className="separator" />
          <ul className="contacts-list">
            <li className="contact-item">
              <div className="icon-box">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="ionicon m-1.5"
                  viewBox="0 0 512 512"
                >
                  <rect
                    x="48"
                    y="96"
                    width="416"
                    height="320"
                    rx="40"
                    ry="40"
                    fill="none"
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="32"
                  />
                  <path
                    fill="none"
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="32"
                    d="M112 160l144 112 144-112"
                  />
                </svg>
              </div>
              <div className="contact-info">
                <p className="contact-title">Email</p>
                <a
                  className="contact-link"
                  href="mailto:ujjwalhiranwar@gmail.com"
                >
                  ujjwalhiranwar@gmail.com
                </a>
              </div>
            </li>
            <li className="contact-item">
              <div className="icon-box">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="ionicon m-1.5"
                  viewBox="0 0 512 512"
                >
                  <path
                    d="M451 374c-15.88-16-54.34-39.35-73-48.76-24.3-12.24-26.3-13.24-45.4.95-12.74 9.47-21.21 17.93-36.12 14.75s-47.31-21.11-75.68-49.39-47.34-61.62-50.53-76.48 5.41-23.23 14.79-36c13.22-18 12.22-21 .92-45.3-8.81-18.9-32.84-57-48.9-72.8C119.9 44 119.9 47 108.83 51.6A160.15 160.15 0 0083 65.37C67 76 58.12 84.83 51.91 98.1s-9 44.38 23.07 102.64 54.57 88.05 101.14 134.49S258.5 406.64 310.85 436c64.76 36.27 89.6 29.2 102.91 23s22.18-15 32.83-31a159.09 159.09 0 0013.8-25.8C465 391.17 468 391.17 451 374z"
                    fill="none"
                    stroke="currentColor"
                    stroke-miterlimit="10"
                    stroke-width="32"
                  />
                </svg>
              </div>
              <div className="contact-info">
                <p className="contact-title">Phone</p>
                <a className="contact-link" href="tel:+919284086977">
                  +91 9284086977
                </a>
              </div>
            </li>
            <li className="contact-item">
              <div className="icon-box">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="ionicon m-1.5"
                  viewBox="0 0 512 512"
                >
                  <rect
                    fill="none"
                    stroke="currentColor"
                    stroke-linejoin="round"
                    stroke-width="32"
                    x="48"
                    y="80"
                    width="416"
                    height="384"
                    rx="48"
                  />
                  <circle cx="296" cy="232" r="24" />
                  <circle cx="376" cy="232" r="24" />
                  <circle cx="296" cy="312" r="24" />
                  <circle cx="376" cy="312" r="24" />
                  <circle cx="136" cy="312" r="24" />
                  <circle cx="216" cy="312" r="24" />
                  <circle cx="136" cy="392" r="24" />
                  <circle cx="216" cy="392" r="24" />
                  <circle cx="296" cy="392" r="24" />
                  <path
                    fill="none"
                    stroke="currentColor"
                    stroke-linejoin="round"
                    stroke-width="32"
                    stroke-linecap="round"
                    d="M128 48v32M384 48v32"
                  />
                  <path
                    fill="none"
                    stroke="currentColor"
                    stroke-linejoin="round"
                    stroke-width="32"
                    d="M464 160H48"
                  />
                </svg>
              </div>
              <div className="contact-info">
                <p className="contact-title">Birthday</p>
                <time dateTime="2004-10-23">March 15, 2005</time>
              </div>
            </li>
            <li className="contact-item">
              <div className="icon-box">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="ionicon m-1.5"
                  viewBox="0 0 512 512"
                >
                  <path
                    d="M256 48c-79.5 0-144 61.39-144 137 0 87 96 224.87 131.25 272.49a15.77 15.77 0 0025.5 0C304 409.89 400 272.07 400 185c0-75.61-64.5-137-144-137z"
                    fill="none"
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="32"
                  />
                  <circle
                    cx="256"
                    cy="192"
                    r="48"
                    fill="none"
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="32"
                  />
                </svg>
              </div>
              <div className="contact-info">
                <p className="contact-title">Location</p>
                <address>Nagpur,India</address>
              </div>
            </li>
          </ul>
          <div className="separator" />
          <ul className="social-list">
          <li className="social-item">
              <a className="social-link" href="https://x.com/UjwalHiranwar" target="_blank" rel="noreferrer">
                <img src={twitter} alt="twitter" className='m-[1px]' height={17} width={17} />
              </a>
            </li>
            <li className="social-item">
            <a
                className="social-link"
                href="https://www.linkedin.com/in/ujwal-hiranwar"
                target="_blank"
                rel="noreferrer"
              >
                <img src={linkedin} alt="linkedin" className='m-[1px]' height={18} width={18}/>
              </a>
             
            </li>
            
            <li className="social-item">
            
            <a className="social-link" href="https://www.instagram.com/_u.z.i___/?hl=en" target="_blank" rel="noreferrer">
                <img src={instagram} alt="instagram" className='m-[1px]' height={17} width={17} />
              </a>
            </li>
            <li className="social-item">
              
              <a
                className="social-link"
                href="https://github.com/Ujwal-Hiranwar"
                target="_blank"
                rel="noreferrer"
              >
                <img src={github} alt="github" className='m-[1px]' height={19} width={19}/>
              </a>
            </li>
            <li className="social-item">
             
              <a
                className="social-link"
                href="https://ujwalhiranwar.medium.com/"
                target="_blank"
                rel="noreferrer"
              >
                <svg xmlns="http://www.w3.org/2000/svg" height="18" width="18" viewBox="0 0 1043.84 592.71" fill="currentColor">
                  <path d="M588.67 296.36c0 163.67-131.78 296.35-294.33 296.35S0 460 0 296.36 131.78 0 294.34 0s294.33 132.69 294.33 296.36M917.44 296.36c0 154.06-65.89 279-147.17 279s-147.17-124.94-147.17-279 65.88-279 147.17-279 147.17 124.9 147.17 279M1043.84 296.36c0 138-23.17 249.94-51.76 249.94s-51.75-111.91-51.75-249.94 23.17-249.94 51.75-249.94 51.76 111.9 51.76 249.94"/>
                </svg>
              </a>
            </li>
          </ul>
        </div>
      </aside>
    </>
  )
}
